import 'scss/app.scss';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'react-phone-number-input/style.css';
import Routes from 'routes/Routes';

function App() {
  return (
      <>
        <Routes />
      </>
  );
}

export default App;
